// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bU-9","rootNoMargin":"styles_rootNoMargin__21A2_"};